import React from 'react';
import { useTranslation } from 'react-i18next';

const TouchposeTutorials = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full mt-[47px] px-[72px]">
      <h1 className="text-2xl font-bold">{t('tutorials.title')}</h1>
      <p className="mt-4 text-gray-600">{t('tutorials.subtitle')}</p>
    </div>
  );
};

export default TouchposeTutorials;
